import BaseApiClient from '../BaseApiClient';
import {
  DashboardNewVsWonStatInterface,
  DashboardInsuranceStatInterface
} from '@interfaces/DashboardStats.interface';

export class ApiDashboard extends BaseApiClient {
  async getTasksNewVsWonStats(interval: string): Promise<{
    items: DashboardNewVsWonStatInterface[];
    total: DashboardNewVsWonStatInterface;
  }> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/dashboard-stats/task-new-vs-won?interval=${interval}`)
        .then((res) => {
          if (res.data) {
            resolve({ items: res.data.data, total: res.data.total });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async getInsuranceOverviewStats(interval: string): Promise<{
    items: DashboardInsuranceStatInterface[];
    total: DashboardInsuranceStatInterface;
  }> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/dashboard-stats/insurance-overview?interval=${interval}`)
        .then((res) => {
          if (res.data) {
            resolve({ items: res.data.data, total: res.data.total });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { dashboardQueryKeys } from './query-keys';
export {
  useDashboardInsuranceOverviewQuery,
  useDashboardTasksNewVsWonQuery
} from './use-dashboard-queries';
